import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next';
import PDFViewer from './PDFViewer';

export default function Intro() {
  const { t } = useTranslation();

  return (
    <Typography component="div" variant="body1">
      <Box color="primary.main">{t('แนะนำการใช้งาน')}</Box>
      <PDFViewer />
    </Typography>
  );
}
